import React from 'react';
import {
  Free,
  Point,
  Point10,
  Point5,
  Point7,
  SpecialBox,
  SpecialWrapper,
  Table,
  TeamName,
  Three,
  Winner,
} from './styled';
import { observer } from 'mobx-react';

const BoxScore = observer(({ detail }) => {
  const { home, away, homeScore, awayScore, sets } = detail;
  const totalKill = sets.slice(0, 5).reduce((sum, set) => sum + set.home.kill + set.away.kill, 0);

  return (
    <Table>
      <colgroup>
        <col width={147} />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th>1set</th>
          <th>2set</th>
          <th>3set</th>
          <th>4set</th>
          <th>5set</th>
          <th>총합</th>
        </tr>
      </thead>
      <tbody>
        <TeamRow teamData={away} position={'AWAY'} setScore={awayScore} detail={detail} />
        <TeamRow teamData={home} position={'HOME'} setScore={homeScore} detail={detail} />
      </tbody>
      <tfoot>
        <tr>
          <th></th>
          <td>{sets[0] ? sets[0].home.kill + sets[0].away.kill : null}</td>
          <td>{sets[1] ? sets[1].home.kill + sets[1].away.kill : null}</td>
          <td>{sets[2] ? sets[2].home.kill + sets[2].away.kill : null}</td>
          <td>{sets[3] ? sets[3].home.kill + sets[3].away.kill : null}</td>
          <td>{sets[4] ? sets[4].home.kill + sets[4].away.kill : null}</td>
          <td>{totalKill}</td>
        </tr>
      </tfoot>
    </Table>
  );
});

const TeamRow = ({ teamData, position, setScore, detail }) => {
  const { sets } = detail;
  const { name_en } = teamData;
  let totalKillScore = 0;
  let teamSets = [];
  if (position === 'HOME') {
    sets.forEach((set) => {
      set.home.win = !!set.win.home;

      teamSets.push(set.home);
      totalKillScore += set.home.kill;
    });
  } else {
    sets.forEach((set) => {
      set.away.win = !!set.win.away;

      teamSets.push(set.away);
      totalKillScore += set.away.kill;
    });
  }

  return (
    <tr>
      <th>
        <div>
          {name_en}
          <TeamName position={position} />
        </div>
        <span>{setScore}</span>
      </th>
      <td>
        {teamSets[0]?.kill} {teamSets[0]?.win && <Winner>승</Winner>}
        <Special specialData={sets[0] || null} position={position} />
      </td>
      <td>
        {teamSets[1]?.kill} {teamSets[1]?.win && <Winner>승</Winner>}
        <Special specialData={sets[1] || null} position={position} />
      </td>
      <td>
        {teamSets[2]?.kill} {teamSets[2]?.win && <Winner>승</Winner>}
        <Special specialData={sets[2] || null} position={position} />
      </td>
      <td>
        {teamSets[3]?.kill} {teamSets[3]?.win && <Winner>승</Winner>}
        <Special specialData={sets[3] || null} position={position} />
      </td>
      <td>
        {teamSets[4]?.kill} {teamSets[4]?.win && <Winner>승</Winner>}
        <Special specialData={sets[4] || null} position={position} />
      </td>
      <td>{totalKillScore}</td>
    </tr>
  );
};

const Special = ({ specialData, position }) => {
  const team = position === 'HOME' ? 'b' : 'r';

  const { firstBlood, firstDragon, firstTower, firstBaron, first10Kill } = specialData || {};

  return (
    <SpecialWrapper>
      <SpecialBox $status={firstBlood === team ? 'letter' : undefined}>킬</SpecialBox>
      <SpecialBox $status={firstDragon === team ? 'letter' : undefined}>용</SpecialBox>
      <SpecialBox $status={firstTower === team ? 'letter' : undefined}>포</SpecialBox>
      <SpecialBox $status={firstBaron === team ? 'letter' : undefined}>바</SpecialBox>
      <SpecialBox $status={first10Kill === team ? 'number' : undefined}>10</SpecialBox>
    </SpecialWrapper>
  );
};

export default BoxScore;
